import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '../../../GlobalUI';

function AdobeTaggingForm({ enabled, onToggle }) {
  return (
    <div className="setup-config-section">
      <div className="setup-config-header">Adobe Tagging</div>
      <div className="setup-config-content">
        <b>Enable Stellantis Adobe tagging</b>
        <Toggle value={enabled} onToggle={onToggle} />
      </div>
    </div>
  );
}

AdobeTaggingForm.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default AdobeTaggingForm;
